import { DEFAULT_MOCKUP_GENERATION_LOGS_PARAMS } from './defaults';

export default {
    clearMockupGenerationLogsFilters: (state: any) => {
        state.queryParams = { ...DEFAULT_MOCKUP_GENERATION_LOGS_PARAMS() };
    },
    setMockupGenerationLogsQueryParams: (state: any, action: any) => {
        state.queryParams = { ...state.queryParams, ...action.payload };
    },
    clearMockupGenerationLog: (state: any) => {
        state.singleLog = null;
        state.singleStatus = null;
        state.singleError = null;
    },
};
